/**
 * POSIX single-quoting for a value going into a remote shell command.
 *
 * **Its own module, not a helper inside the view that uses it.** This is a
 * security boundary: filenames on a server are attacker-controlled as far as
 * this app is concerned — a file called `; rm -rf ~ #` is a perfectly legal
 * name, and interpolating it raw into `zip -r ...` runs it. A function like
 * that should be importable by a test without dragging a whole Tauri-bound
 * component in behind it, and importable by the next caller without them
 * deciding to write their own.
 *
 * Wrapping in single quotes makes every character literal to the shell. The one
 * character a single-quoted string cannot contain is a single quote, so each is
 * closed, escaped and reopened (`'\''`).
 */
export function shQuote(value) {
  return `'${String(value).replace(/'/g, "'\\''")}'`;
}

export default shQuote;
